import createIcon from '../../createIcon';

/**
 * @component @name Spoke
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTYgN0MxNiA5LjIxIDE0LjIxIDExIDEyIDExQzkuNzkgMTEgOCA5LjIxIDggN0M4IDQuNzkgOS43OSAzIDEyIDNDMTQuMjEgMyAxNiA0Ljc5IDE2IDdaTTcgMTNDNC43OSAxMyAzIDE0Ljc5IDMgMTdDMyAxOS4yMSA0Ljc5IDIxIDcgMjFDOS4yMSAyMSAxMSAxOS4yMSAxMSAxN0MxMSAxNC43OSA5LjIxIDEzIDcgMTNaTTE3IDEzQzE0Ljc5IDEzIDEzIDE0Ljc5IDEzIDE3QzEzIDE5LjIxIDE0Ljc5IDIxIDE3IDIxQzE5LjIxIDIxIDIxIDE5LjIxIDIxIDE3QzIxIDE0Ljc5IDE5LjIxIDEzIDE3IDEzWiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Spoke = createIcon('Spoke', [
  [
    'path',
    {
      d: 'M16 7C16 9.21 14.21 11 12 11C9.79 11 8 9.21 8 7C8 4.79 9.79 3 12 3C14.21 3 16 4.79 16 7ZM7 13C4.79 13 3 14.79 3 17C3 19.21 4.79 21 7 21C9.21 21 11 19.21 11 17C11 14.79 9.21 13 7 13ZM17 13C14.79 13 13 14.79 13 17C13 19.21 14.79 21 17 21C19.21 21 21 19.21 21 17C21 14.79 19.21 13 17 13Z',
      key: '1obtbe',
    },
  ],
]);

export default Spoke;
